import AdminNavbar from './AdminNavbar';
import AdminSidebar from './AdminSidebar';

export default function AdminLayout({ activeTab, children, onTabChange, tabs, user }) {
  return (
    <main className="commerce-page admin-page">
      <div className="container">
        <AdminNavbar user={user} />
        <AdminSidebar activeTab={activeTab} onTabChange={onTabChange} tabs={tabs} />
        {children}
      </div>
    </main>
  );
}
